import { useState, useCallback } from 'react';

import type { Collaborator } from '../@types/forms/types';
import { isValidEmail } from '../sections/forms/utils/validations';

interface UseCollaboratorValidationReturn {
  collaboratorsErrors: string[];
  setCollaboratorsErrors: React.Dispatch<React.SetStateAction<string[]>>;
  validateCollaborators: (collaborators: Collaborator[]) => boolean;
}

/**
 * Custom hook for collaborator validation logic
 * Handles email validation for collaborators
 */
export const useCollaboratorValidation = (): UseCollaboratorValidationReturn => {
  const [collaboratorsErrors, setCollaboratorsErrors] = useState<string[]>([]);

  const validateCollaborators = useCallback(
    (collaborators: Collaborator[]): boolean => {
      const newCollaboratorsErrors: string[] = [];

      collaborators.forEach((c) => {
        if (!c.email) {
          newCollaboratorsErrors.push(c.collaboratorId);
        } else {
          const isCollaboratorValidEmail = isValidEmail(c.email);

          if (!isCollaboratorValidEmail) {
            newCollaboratorsErrors.push(c.collaboratorId);
          }
        }
      });

      setCollaboratorsErrors(newCollaboratorsErrors);

      return newCollaboratorsErrors.length === 0;
    },
    [setCollaboratorsErrors]
  );

  return {
    collaboratorsErrors,
    setCollaboratorsErrors,
    validateCollaborators,
  };
};
